import lrSecretLevelSelect from './_src/lrSecretLevelSelect.vue'

lrSecretLevelSelect.install = function(Vue) {
  Vue.component(lrSecretLevelSelect.name, lrSecretLevelSelect)
}

export default lrSecretLevelSelect